import { styled } from '@mui/material/styles';
import { DataGrid, gridClasses } from '@mui/x-data-grid';

export const RecentOrdersStyledDataGrid = styled(DataGrid)(({ theme }) => ({
  border: 0,
  fontStyle: 'normal',
  '--DataGrid-containerBackground': 'white',
  '& .MuiDataGrid-columnHeaderTitle': {
    fontSize: theme.typography.subtitle200?.fontSize, 
    fontWeight: theme.typography?.fontWeightMedium,
    padding: '24px 32px 24px 32px',
    borderBottom: '1px solid var(--Border-medium-emphasis, rgba(0, 0, 0, 0.10))',
  },
  '& .MuiDataGrid-row': {
    borderTop: '1px solid var(--Border-medium-emphasis, rgba(0, 0, 0, 0.10))',
  },
  '& .MuiDataGrid-footerContainer': {
    borderTop: '1px solid var(--Border-medium-emphasis, rgba(0, 0, 0, 0.10))',
  },
  "& .MuiDataGrid-row:hover": {
    backgroundColor: "unset"
  },
  "& .MuiDataGrid-row.Mui-hovered": {
    backgroundColor: "unset",
  },
  '& .MuiDataGrid-iconSeparator': {
    display: 'none',
  },
  '& .MuiDataGrid-columnSeparator': {
    display: 'none',
  },
  '& .MuiDataGrid-columnHeader, .MuiDataGrid-cell': {
    borderRight: 'none',
    outline: 'none !important',
    padding: '0px'
  },
  '& .MuiDataGrid-columnsContainer, .MuiDataGrid-cell': {
    outline: 'none !important',
    textAlign: 'left',
  },
  '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': {
    display: 'none'
  },
  '.MuiDataGrid-cell' :{
    padding: '24px 32px 24px 32px',
    lineHeight: '0px',
  },
  [`& .${gridClasses.cell}.left`]: {
    fontSize: theme.typography.subtitle300?.fontSize, 
    borderBottom: "1px solid #E5E6E7",
  },
  [`& .${gridClasses.cell}.right`]: {
    fontSize: theme.typography.subtitle200?.fontSize, 
    fontWeight: theme.typography?.fontWeightMedium,
    borderBottom: "1px solid #E5E6E7",
  },
}));